import { makeAutoObservable, runInAction } from 'mobx';

class ChatStore {
  /**
   * @param {Store} root
   */
  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
  }

  // Chat state
  messages = [];
  isLoading = false;
  error = null;
  currentSessionId = null;

  // Message management
  addUserMessage(content) {
    const message = {
      id: Date.now() + Math.random(),
      type: 'user',
      content,
      timestamp: new Date(),
      sessionId: this.currentSessionId
    };

    runInAction(() => {
      this.messages.push(message);
    });

    return message;
  }

  addAIMessage(content) {
    const message = {
      id: Date.now() + Math.random(),
      type: 'ai',
      content,
      timestamp: new Date(),
      sessionId: this.currentSessionId
    };

    runInAction(() => {
      this.messages.push(message);
      this.isLoading = false;
    });

    return message;
  }

  setLoading(loading) {
    runInAction(() => {
      this.isLoading = loading;
    });
  }

  setError(error) {
    runInAction(() => {
      this.error = error;
      this.isLoading = false;
    });
  }

  clearError() {
    runInAction(() => {
      this.error = null;
    });
  }

  // Session management
  startNewSession() {
    runInAction(() => {
      this.currentSessionId = `session_${Date.now()}`;
      this.messages = [];
      this.error = null;
      this.isLoading = false;
    });
  }

  // API methods (stubs for now)
  async sendMessage(content) {
    try {
      this.clearError();

      // Add user message immediately
      this.addUserMessage(content);

      // Set loading state
      this.setLoading(true);

      // TODO: Implement actual API call to chat service
      // For now, simulate with a timeout
      setTimeout(() => {
        this.addAIMessage(`You said: "${content}". This is a mock response.`);
      }, 1000);

    } catch (error) {
      console.error('Failed to send message:', error);
      this.setError(error.message || 'Failed to send message');
    }
  }

  // Getters
  get messagesForCurrentSession() {
    return this.messages.filter(msg => msg.sessionId === this.currentSessionId);
  }

  get hasMessages() {
    return this.messages.length > 0;
  }

  get lastMessage() {
    return this.messages[this.messages.length - 1];
  }
}

export default ChatStore;